// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: label, icon and colour for each Home swipe action, shared by the Home rows, the
// short-swipe tray and Settings > Customise Home > Swipe actions. Colours match the phone
// mail swipe (MailSwipeRow MAIL_SWIPE_TONE) so a swipe means the same colour everywhere.

import type {HomeSwipeAction} from '@app/features/konvo_today/state/HomePreferences';
import {
	ArrowBendUpLeftIcon,
	CheckIcon,
	CheckSquareIcon,
	ClockIcon,
	ProhibitIcon,
	SparkleIcon,
	XIcon,
} from '@app/features/ui/icons/Icons';
import type {MessageDescriptor} from '@lingui/core';
import {msg} from '@lingui/core/macro';
import type React from 'react';

export const HOME_SWIPE_ACTION_LABEL: Record<HomeSwipeAction, MessageDescriptor> = {
	done: msg({message: 'Done', comment: 'Home swipe action that ticks off an item. Short tile label.'}),
	reply: msg({message: 'Reply', comment: 'Home swipe action that opens a reply. Short tile label.'}),
	later: msg({message: 'Later', comment: 'Home swipe action that snoozes an item. Short tile label.'}),
	dismiss: msg({message: 'Dismiss', comment: 'Home swipe action that removes an item from Home. Short tile label.'}),
	task: msg({message: 'Task', comment: 'Home swipe action that makes a ClickUp task. Short tile label.'}),
	ask: msg({
		message: 'Ask Konvo',
		comment: 'Home swipe action that asks the assistant about an item. Short tile label.',
	}),
	none: msg({message: 'None', comment: 'Home swipe setting: the swipe does nothing. Short tile label.'}),
};

/** Track colour for each action; mail's green / blue / amber / slate / violet. */
export const HOME_SWIPE_ACTION_TONE: Record<Exclude<HomeSwipeAction, 'none'>, string> = {
	done: '#2e9d5b',
	reply: '#2f6fe4',
	later: '#c98f06',
	dismiss: '#5b6b82',
	task: '#7b5cf0',
	ask: 'var(--brand-primary)',
};

export function homeSwipeActionIcon(action: HomeSwipeAction, size = 22): React.ReactNode {
	switch (action) {
		case 'done':
			return <CheckIcon size={size} />;
		case 'reply':
			return <ArrowBendUpLeftIcon size={size} />;
		case 'later':
			return <ClockIcon size={size} />;
		case 'dismiss':
			return <XIcon size={size} />;
		case 'task':
			return <CheckSquareIcon size={size} />;
		case 'ask':
			return <SparkleIcon size={size} />;
		case 'none':
			return <ProhibitIcon size={size} />;
	}
}
